import Colors from "@constants/Colors";
import { Box } from "@mui/material";
import styled from "styled-components";

export const CustomCardWrapperDesktop = styled(Box)<{
  minHeight?: string;
  isSummary?: boolean;
}>`
  min-height: ${({ minHeight }: { minHeight?: string }) =>
    minHeight || ""}!important;
  top: 164px;
  max-width: ${(props) => (props.isSummary ? "" : "360px")};
  padding: ${(props) => (props.isSummary ? "36px 36px 0px 36px" : "")};
  min-width: 350px;
`;
export const StyledRootBoxDesktop = styled(Box)`
  padding: 36px;
  gap: 24px;
  background-color: ${Colors.neutralwhite_50};
  display: flex;
  flex-wrap: wrap;
`;

export const CustomCardWrapper = styled(Box)<{ minHeight?: string }>`
  min-height: ${({ minHeight }: { minHeight?: string }) =>
    minHeight || ""}!important;
  top: 164px;
  padding: 16px 16px 0px 16px !important;
`;
export const StyledRootBox = styled(Box)`
  background-color: ${Colors.neutralwhite_50};
`;
